import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Panel from '../../../UniformComponents/Panel'
import Select from '../../form/Select'

@observer
class DownloadModal extends Component {
    render() {
        const { distributeStore } = this.props

        return (
            <Modal
                show={distributeStore.downloadModalVisible}
                onClose={distributeStore.hideDownloadModal}
            >
                {!distributeStore.userDownloadUrl
                    ? (
                        <div>
                            <div className="uc-modal__header">
                                <Typography type="h2">{i18n.t('download.modal.export_options')}</Typography>
                            </div>
                            <br />

                            {distributeStore.downloadModalLoading
                                ? (
                                    <div className="download-modal-loading">
                                        <p>{i18n.t('downloadModal.processing')}</p>

                                        <div className="loader" />
                                    </div>
                                )
                                : (
                                    <div>
                                        <div className="download-modal-options">
                                            <Panel
                                                onClick={() => distributeStore.download('userdata')}
                                                cssClass="download-modal-option"
                                            >
                                                <div className="download-modal-option-container">
                                                    <i className="far fa-download" />

                                                    <Typography>{i18n.t('downloadModal.userLinks')}</Typography>
                                                </div>
                                            </Panel>

                                            <Panel
                                                onClick={() => distributeStore.download('optout')}
                                                cssClass="download-modal-option"
                                            >
                                                <div className="download-modal-option-container">
                                                    <i className="far fa-download" />

                                                    <Typography>{i18n.t('downloadModal.optout')}</Typography>
                                                </div>
                                            </Panel>

                                            <Panel
                                                onClick={() => distributeStore.download('invalid')}
                                                cssClass="download-modal-option"
                                            >
                                                <div className="download-modal-option-container">
                                                    <i className="far fa-download" />

                                                    <Typography>{i18n.t('downloadModal.nonvalid')}</Typography>
                                                </div>
                                            </Panel>
                                        </div>

                                        <br />

                                        <br />

                                        <div>
                                            <Select
                                                label={i18n.t('change_delimiter')}
                                                clearable={false}
                                                defaultValue={distributeStore.downloadDelimiter}
                                                options={[
                                                    { value: 'semicolon', label: i18n.t('downloadModal.semicolon') },
                                                    { value: 'comma', label: i18n.t('downloadModal.comma') },
                                                    { value: 'tab', label: i18n.t('downloadModal.tab') },
                                                ]}
                                                onBlur={(obj) => distributeStore.changeDownloadDelimiter(obj.value)}
                                            />
                                        </div>
                                    </div>
                                )}
                        </div>
                    )
                    : null}

                {distributeStore.userDownloadUrl
                    ? (
                        <div>
                            <div className="uc-modal__header">
                                <Typography type="h2">{i18n.t('download.modal.export_options')}</Typography>
                            </div>

                            <br />

                            <div className="email-list-modal">
                                <Typography>{i18n.t('downloadModal.fileready')}</Typography>
                            </div>

                            <br />

                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <a href={distributeStore.userDownloadUrl} className="uc-button regular primary" style={{ gap: 5 }}>
                                    <i className="fal fa-folder-arrow-down" />

                                    {i18n.t('downloadModal.textAction')}
                                </a>
                            </div>
                        </div>
                    )
                    : null}
            </Modal>
        )
    }
}

export default DownloadModal
